import * as React from "react";
import { Dispatch } from "react";
import styled from "@mui/material/styles/styled";

import { QualifiedFeature } from "fe-common/graphql";
import { DataInput } from "../../dataInputTypes";

import CheckedCheckbox from "../../../assets/wizardCheckedCheckbox.svg";
import EmptyCheckbox from "../../../assets/wizardEmptyCheckbox.svg";

import { Checkbox } from "@mui/material";
import { MobileView } from "../../../util/aKaunGeneralUtil";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";

//region [[ Styles ]]

const CheckboxButtonComponentView = styled("div")(({ theme }) => ({
  display: "flex",
  marginLeft: "-10px",
  [theme.breakpoints.down(MobileView)]: {
    marginLeft: "-10px",
  },
}));

//endregion [[ Styles ]]

//region [[ Props ]]

export interface CheckboxButtonComponentProps {
  qf: QualifiedFeature;
  dataInput?: DataInput;
  onChange: Dispatch<DataInput>;
  disabled: boolean;
  isThreeway?: boolean;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const CheckboxButtonComponent = ({
  ...props
}: CheckboxButtonComponentProps) => {
  const onChangeValue = () => {
    if (props.isThreeway === true) {
      if (!props.dataInput || props.dataInput.negate === undefined) {
        props.onChange({ negate: false });
      } else if (props.dataInput && props.dataInput.negate === false) {
        props.onChange({ negate: true });
      } else {
        props.onChange(null);
      }
    } else {
      if (!props.dataInput || props.dataInput.negate === undefined) {
        props.onChange({ negate: false });
      } else {
        props.onChange(null);
      }
    }
  };

  return (
    <CheckboxButtonComponentView>
      <Checkbox
        checked={
          props.dataInput && props.dataInput.negate !== undefined ? true : false
        }
        checkedIcon={<img src={CheckedCheckbox} alt={"checked"} />}
        icon={<img src={EmptyCheckbox} alt={"checked"} />}
        style={{
          color: props.dataInput
            ? props.dataInput.negate
              ? KahunColorMap.Secondary
              : KahunColorMap.Red
            : KahunColorMap.Default,
        }}
        onChange={onChangeValue}
        inputProps={{ "aria-label": "primary checkbox" }}
      />
    </CheckboxButtonComponentView>
  );
};
